import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';

/** The slot the Reports section keeps next to its title for the active tab. */
export const TAB_ACTION_PORTAL_ID = 'ipma-reports-buttons-portal';

/**
 * Renders the action of a tab into the header of the Reports section.
 *
 * The section owns the title and the tab bar, so a tab cannot draw its own
 * header any more - but the export button of the MA reports still belongs up
 * there next to the title rather than buried above the table.
 *
 * The slot lives in a component that renders after this one on the first pass,
 * so the node is looked up once mounted rather than during the render itself.
 */
const TabActionPortal = ({ children }) => {
  const [slot, setSlot] = useState(null);

  useEffect(() => {
    setSlot(document.getElementById(TAB_ACTION_PORTAL_ID));
  }, []);

  return slot ? ReactDOM.createPortal(children, slot) : null;
};

TabActionPortal.propTypes = {
  children: PropTypes.node,
};

TabActionPortal.defaultProps = {
  children: null,
};

export default TabActionPortal;
